import React from 'react';
import { useParams } from 'react-router-dom';
import { useDocument } from 'react-firebase-hooks/firestore';
import { Card, Rate } from 'antd';
import Client from 'containers/app/client';
import './style.css';

const RatingAverage = ({ role, userId }) => {
  const { id } = useParams();
  userId = userId || id;

  const isWorker = role === 'isWorker';

  const bookingsRef = isWorker
    ? Client.db.collection('bookings').where('worker', '==', userId)
    : Client.db.collection('bookings').where('userId', '==', userId);
  const [bookings, bookingsLoading, bookingsError] = useDocument(bookingsRef);

  if (bookingsLoading) return null;
  if (bookingsError) throw bookingsError;

  const bookingsWithRates = isWorker
    ? bookings.docs
        .filter((item) => item.data().gradeWorker)
        .map((item) => item.data().gradeWorker)
    : bookings.docs
        .filter((item) => item.data().gradeEmployer)
        .map((item) => item.data().gradeEmployer);

  const grade =
    bookingsWithRates.reduce((a, b) => a + b, 0) / bookingsWithRates.length;

  return (
    <>
      {bookingsWithRates.length > 0 ? (
        <Card
          title="Average Rating"
          headStyle={{ textAlign: 'center' }}
        >
          <Rate disabled allowHalf value={grade} />
        </Card>
      ) : null}
    </>
  );
};

export default RatingAverage;
